import React, { useState, useEffect } from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Typography, LinearProgress } from '@mui/material';
import { useI18n } from '../hooks/useI18n';

export default function IdlePromptDialog({ open, onStay, onLogout, countdown = 60 }) {

  const { t } = useI18n(['auth', 'common']);
  const [remaining, setRemaining] = useState(countdown);

  useEffect(() => {
    if (open) {
      setRemaining(countdown);
      const interval = setInterval(() => {
        setRemaining(prev => {
          if (prev <= 1) {
            clearInterval(interval);
            onLogout();
            return 0;
          }
          return prev - 1;
        });
      }, 1000);

      return () => clearInterval(interval);
    }
  }, [open, countdown, onLogout]);

  const progress = (remaining / countdown) * 100;

  return (
    <Dialog open={open} maxWidth="xs" fullWidth>
      <DialogTitle>{t('idlePrompt.title', { defaultValue: 'Sessione in Scadenza' })}</DialogTitle>
      <DialogContent>
        <Typography>
          {t('idlePrompt.message', { defaultValue: 'Stai per essere disconnesso per inattività.' })}
        </Typography>
        <Typography variant="body2" color="text.secondary" sx={{ mt: 2 }}>
          {t('idlePrompt.countdown', { count: remaining, defaultValue: `Verrai disconnesso tra ${remaining} secondi.` })}
        </Typography>
        <LinearProgress variant="determinate" value={progress} sx={{ mt: 1 }} />
      </DialogContent>
      <DialogActions>
        <Button onClick={onLogout} variant="outlined">
          {t('logout.title', { defaultValue: 'Log out' })}
        </Button>
        <Button onClick={onStay} variant="contained" color="success" autoFocus>
          {t('idlePrompt.stay', { defaultValue: 'Resta Connesso' })}
        </Button>
      </DialogActions>
    </Dialog>
  );
}